import { VITE_API_URL } from '@/processENV';
import { store } from '@/app/store/store';
import { activeRightStack } from '@/app/store/navigationSlice';
import { setActiveMeetLink } from '@/features/calendar/model/calendarSlice';
import { setAlertModal } from '@/components/AlertModalRoot/alertModalService';
import { CALLKIT_CALLSCREENSTATUS, CALLKIT_CALLUISTATE } from '@/features/calls/constants';
import { setCallUIState } from '@/features/calls/model/callkitDataSlice';
import { endCallKitCall } from '@/features/calls/utils/sdkCallMethods';
import { i18n } from '@/localization/i18n';

/**
 * Checks if a given URL string matches the internal API URL,
 * meaning it is a generated meeting link.
 *
 * @param {string} url - The URL to check
 * @returns {boolean} True if internal meeting link, false otherwise
 */
export const isInternalMeetLink = url => {
   if (!url || typeof url !== 'string') return false;
   try {
      const apiOrigin = new URL(VITE_API_URL).origin;
      return url.startsWith(`${apiOrigin}/call/`);
   } catch {
      return false;
   }
};

/**
 * Handles the logic for a user clicking a meet link.
 * Shows a confirmation popup if the user is already in an active call.
 */
export const handleJoinMeetLink = (href, dispatch) => {
   const state = store.getState();
   const { callScreenStatus, callLink } = state.callkitData;
   const { activeMeetLink } = state.calendarData;

   const isActiveCall =
      callScreenStatus &&
      callScreenStatus !== CALLKIT_CALLSCREENSTATUS.ENDED &&
      callScreenStatus !== CALLKIT_CALLSCREENSTATUS.IDLE;

   if (isActiveCall) {
      const currentCallLink = callLink || activeMeetLink;
      if (currentCallLink === href) {
         dispatch(setCallUIState(CALLKIT_CALLUISTATE.MAXIMIZED));
         dispatch(activeRightStack({ activeStack: '' }));
         return;
      }

      setAlertModal({
         id: 'switchCallModal',
         title: i18n.t('calls.SWITCH_CALL_CONFIRM', { defaultValue: 'Proceed with another call' }),
         visible: true,
         noButton: i18n.t('common.NO'),
         noAction: () => {},
         yesButton: i18n.t('common.YES'),
         yesAction: () => {
            endCallKitCall(() => {
               dispatch(setActiveMeetLink(href));
               dispatch(activeRightStack({ activeStack: 'joinMeeting' }));
            });
         },
      });
   } else {
      dispatch(setActiveMeetLink(href));
      dispatch(activeRightStack({ activeStack: 'joinMeeting' }));
   }
};
